type DownloadLink = {
  __typename?: 'Download';
  low?: {
    __typename?: 'DownloadLink';
    link: string;
    width: number;
    height: number;
    filesize: number;
  } | null;
  medium?: {
    __typename?: 'DownloadLink';
    link: string;
    width: number;
    height: number;
    filesize: number;
  } | null;
  high?: {
    __typename?: 'DownloadLink';
    link: string;
    width: number;
    height: number;
    filesize: number;
  } | null;
} | null;

export const toDownloadUrl = (download?: DownloadLink) =>
  download
    ? download?.high?.link || download?.medium?.link || download?.low?.link
    : undefined;
